import { hasValue as s, none as i, isEmpty as y } from "../fp/optional/utils.js";
import { identity as u } from "../fp/utils.js";
const h = (t, n) => t.reduce((e, r) => {
  const o = n(r);
  return e.set(o, [...e.get(o) ?? [], r]);
}, /* @__PURE__ */ new Map()), a = (t, n, e) => t.reduce((r, o) => r.set(n(o), e(o)), /* @__PURE__ */ new Map()), p = (t, n) => a(t, n, u), g = (t) => s(t) && t.length > 0 ? t[0] : i(), m = (t, n) => {
  const e = t[0];
  if (y(e))
    throw n();
  return e;
}, d = (t, n) => {
  if (t.length > 1)
    throw n();
}, w = (t, n) => t.length === n.length && t.every((e) => n.includes(e)) && n.every((e) => t.includes(e)), A = (t) => t.filter(s), E = (t) => Array.from(new Set(t)), M = (t, n) => {
  const e = /* @__PURE__ */ new Set(), r = [];
  for (const o of t) {
    const c = n(o);
    e.has(c) || (e.add(c), r.push(o));
  }
  return r;
}, v = (t) => t === void 0 || t.length === 0, q = (t) => s(t) && Array.isArray(t) && t.length > 0, O = (t, n) => t.length !== n.length ? !1 : t.every((e, r) => e === n[r]);
export {
  w as arraysContainSameElements,
  O as arraysEqual,
  d as assertAtMostOne,
  A as compact,
  g as firstOrNone,
  m as firstOrThrow,
  h as groupBy,
  v as isEmptyArray,
  q as isNonEmptyArray,
  a as toMap,
  p as toMapVal,
  E as uniqArray,
  M as uniqBy
};
//# sourceMappingURL=utils.js.map
